import React, { useState, useEffect } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './Banner';
import Required from './Required';
import Needlessly from './Needlessly';
import Media from './Media';
import FormInfo from './FormInfo';
import FormSubmit from './FormSubmit';
import { submitFormHandle2024, getHostHandle2024, updateFormHandle2024 } from '@src/services/api';
import { Toast, SpinLoading } from 'antd-mobile';
import Confirm from './Confirm';
import Success from './Success';
import { getlocal, setlocal, getStringLenth } from '@src/utils/index';
import SecondShare from './secondShare';

let checkRequiredSucess = false;

const Layout = () => {
    // 提交数据加载态
    const [isShowLoading, setIsShowLoading] = useState(false);
    // 是否勾选知晓信息
    const [understand, setUnderstand] = useState(false);
     // 获取更新id
    const [updateId, setUpdateId] = useState(() => getlocal('_id'));
    const [updateSuccess, setUpdateSuccess] = useState(false);
    // 是否提交
    const [isClickSubmit, setIsClickSubmit] = useState(false);
    // 确认弹窗
    const [confirmData, setConfirmData] = useState({
        isClickOk: false,
        isCheck: false,
        isClosePopup: true,
    });
    // 提交成功弹窗
    const [hasSucessPopup, setHasSucessPopup] = useState(false);
    // 必选项
    const [formData, setFormData] = useState({
        name: '',
        gender: '',
        age: '',
        current_college: '',
        major: '',
        job: '',
        location: '',
        contact_details: '',
        img1: '',
        img2: '',
        video_self: '',
        video_production: '',
        nationality: '',
        language: '',
        self_introduction: '',
        other_platforms: '',
    });
    const [warningTextList, setWarningTextList] = useState({
        name: {
            value: '',
            isScrollTop: false,
        },
        gender: {
            value: '',
            isScrollTop: false,
        },
        age: {
            value: '',
            isScrollTop: false,
        },
        current_college: {
            value: '',
            isScrollTop: false,
        },
        major: {
            value: '',
            isScrollTop: false,
        },
        job: {
            value: '',
            isScrollTop: false,
        },
        location: {
            value: '',
            isScrollTop: false,
        },
        contact_details: {
            value: '',
            isScrollTop: false,
        },
        img: {
            value: '',
            isScrollTop: false,
        },
        video_self: {
            value: '',
            isScrollTop: false,
        },
        video_production: {
            value: '',
            isScrollTop: false,
        },
        nationality: {
            value: '',
            isScrollTop: false,
        },
        language: {
            value: '',
            isScrollTop: false,
        },
        self_introduction: {
            value: '',
            isScrollTop: false,
        },
        other_platforms: {
            value: '',
            isScrollTop: false,
        },
    });

    // 校验表单
    const checkFormDataHandle = () => {
        const dataOrder = [
            'name',
            'gender',
            'age',
            'current_college',
            'major',
            'job',
            'location',
            'contact_details',
            'img1',
            'img2',
            'video_self',
            'video_production',
            'nationality',
            'language',
            'self_introduction',
            'other_platforms',
        ];
        const warningTextListNew = warningTextList;
        const name = formData['name'];
        const gender = formData['gender'];
        const age = formData['age'];
        const current_college = formData['current_college'];
        const major = formData['major'];
        const job = formData['job'];
        const location = formData['location'];
        const contact_details = formData['contact_details'];
        const img1 = formData['img1'];
        const img2 = formData['img2'];
        const video_self = formData['video_self'];
        const video_production = formData['video_production'];
        const nationality = formData['nationality'];
        const language = formData['language'];
        const self_introduction = formData['self_introduction'];
        const other_platforms = formData['other_platforms'];

        // 姓名
        if (name === '') {
            warningTextListNew['name']['value'] = '請輸入姓名';
        } else if (getStringLenth(name) > 100) {
            warningTextListNew['name']['value'] = '姓名已超過最大字數';
        } else {
            warningTextListNew['name']['value'] = '';
        }
        // 性别
        if (gender === '') {
            warningTextListNew['gender']['value'] = '請選擇性別';
        } else {
            warningTextListNew['gender']['value'] = '';
        }
        // 年龄
        if (age === '') {
            warningTextListNew['age']['value'] = '請輸入年齡';
        } else if (age !== '' && !Number(age) && Number(age).toString().length !== getStringLenth(age)) {
            warningTextListNew['age']['value'] = '請輸入數字';
        } else if (age !== '' && getStringLenth(age) > 2) {
            warningTextListNew['age']['value'] = '最大兩位數';
        } else {
            warningTextListNew['age']['value'] = '';
        }
        // 在读/毕业院校
        if (current_college === '') {
            warningTextListNew['current_college']['value'] = '在讀/畢業院校';
        } else if (current_college !== '' && getStringLenth(current_college) > 300) {
            warningTextListNew['current_college']['value'] = '最大300個字符';
        } else {
            warningTextListNew['current_college']['value'] = '';
        }
        // 專業
        if (major === '') {
            warningTextListNew['major']['value'] = '請輸入專業';
        } else if (getStringLenth(major) > 100) {
            warningTextListNew['major']['value'] = '已超過最大字數';
        } else {
            warningTextListNew['major']['value'] = '';
        }
        // 职业
        if (job === '') {
            warningTextListNew['job']['value'] = '請輸入職業';
        } else if (getStringLenth(job) > 100) {
            warningTextListNew['job']['value'] = '已超過最大字數';
        } else {
            warningTextListNew['job']['value'] = '';
        }
        // 常住地
        if (location === '') {
            warningTextListNew['location']['value'] = '請輸入常駐地';
        } else if (getStringLenth(location) > 100) {
            warningTextListNew['location']['value'] = '已超過最大字數';
        } else {
            warningTextListNew['location']['value'] = '';
        }
        // 联系方式
        if (contact_details === '') {
            warningTextListNew['contact_details']['value'] = '請輸入聯繫方式';
        } else if (getStringLenth(contact_details) > 100) {
            warningTextListNew['contact_details']['value'] = '已超過最大字數';
        } else {
            warningTextListNew['contact_details']['value'] = '';
        }
         // 照片
         if (img1 === '' || img2 === '') {
            warningTextListNew['img']['value'] = '請上傳照片';
        } else {
            warningTextListNew['img']['value'] = '';
        }

        // 自我介绍视频
        if (video_self === '') {
            warningTextListNew['video_self']['value'] = '請上傳視頻';
        } else {
            warningTextListNew['video_self']['value'] = '';
        }
        // 视频作品
        // if (video_production === '') {
        //     warningTextListNew['video_production']['value'] = '請上傳視頻';
        // } else {
        //     warningTextListNew['video_production']['value'] = '';
        // }
        // 国籍
        if (nationality !== '' && getStringLenth(nationality) > 100) {
            warningTextListNew['nationality']['value'] = '最大100個字符';
        } else {
            warningTextListNew['nationality']['value'] = '';
        }
        // 语言
        if (language !== '' && getStringLenth(language) > 100) {
            warningTextListNew['language']['value'] = '最大100個字符';
        } else {
            warningTextListNew['language']['value'] = '';
        }
        
        // 介绍一下自己
        if (self_introduction !== '' && getStringLenth(self_introduction) > 1000) {
            warningTextListNew['self_introduction']['value'] = '最大1000個字符';
        } else {
            warningTextListNew['self_introduction']['value'] = '';
        }
        // 还能再哪些平台了解你
        if (other_platforms !== '' && getStringLenth(other_platforms) > 300) {
            warningTextListNew['other_platforms']['value'] = '最大300個字符';
        } else {
            warningTextListNew['other_platforms']['value'] = '';
        }

        let flag = true;

        for (const key in warningTextListNew) {
            warningTextListNew[key]['isScrollTop'] = false;
        }

        for (let i = 0; i < dataOrder.length; i++) {
            if (warningTextList?.[dataOrder[i]]?.['value']) {
                warningTextListNew[dataOrder[i]]['isScrollTop'] = true;
                flag = false;
                break;
            } else {
                flag = true;
            }
        }

        if (!flag) {
            checkRequiredSucess = true;
        } else {
            checkRequiredSucess = false;
        }
        const stringifyData = JSON.stringify(warningTextListNew);
        const parseData = JSON.parse(stringifyData);

        setWarningTextList((data) => {
            return {
                ...data,
                ...parseData,
            };
        });
    };

    const setFormDataHandle = (key, value) => {
        const obj = {};

        obj[key] = value;
        setFormData((data) => {
            return {
                ...data,
                ...obj,
            };
        });
    };

    const understandHandle = (value) => {
        setUnderstand(value);
    };

    const confirmDataHandle = (value) => {
        if (value?.isClickOk === true) {
            setIsShowLoading(true);
        }
        
        setConfirmData(value);
    };

    // 校验表单所有操作
    const checkFormMenuHandle = () => {
        checkFormDataHandle();
        let isSubmitSucess = true;

        if (checkRequiredSucess) {
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否勾选知晓信息
        if (!understand) {
            Toast.show({
                content: '請勾選知曉信息',
                maskClickable: false,
            });
            isSubmitSucess = false;
            setIsClickSubmit(false);

            return false;
        }

        // 验证是否点击确认提交
        if (!confirmData.isClickOk) {
            confirmDataHandle({
                isClickOk: false,
                isCheck: false,
                isClosePopup: false,
            });

            return false;
        }

        return isSubmitSucess;
    };

    const submitFailHandle = () => {
        setIsShowLoading(false);
        confirmDataHandle({
            isClickOk: false,
            isCheck: false,
            isClosePopup: true,
        });
    };

    const submitHandle = async () => {
        // 数据提交
        if (checkFormMenuHandle()) {
            setIsShowLoading(true);
            
            try {
                const submitResult = updateId ? await updateFormHandle2024(formData, updateId) : await submitFormHandle2024(formData);

                if (submitResult?.data?.data && submitResult?.data?.code === 0) {
                    setHasSucessPopup(true);
                    setlocal('_id', submitResult?.data?.data?.data?._id);
                } else {
                    Toast.show({
                        content: submitResult?.data?.message || '未知錯誤，提交失敗，請稍後重試',
                        maskClickable: false,
                    });
                    submitFailHandle();
                }
            } catch (e) {
                Toast.show({
                    content: '未知錯誤，提交失敗，請稍後重試',
                    maskClickable: false,
                });
                submitFailHandle();
            }
            setIsShowLoading(false);
        } else {
            submitFailHandle();
        }
    };

    // 初始化更新表单
    const getHostHandle = async () => {
        setIsShowLoading(true);
        try {
            const hostData = await getHostHandle2024(updateId);

            if (hostData?.data?.data) {
                const { img1_url, img2_url, ...filterHostData } = hostData.data.data;

                setFormData({
                    ...filterHostData
                });
                setlocal('img1FormBase64Url', img1_url);
                setlocal('img2FormBase64Url', img2_url);
                setUpdateSuccess(true);
                setIsShowLoading(false);
            } else {
                setIsShowLoading(false);
            }
        } catch (e) {
            setIsShowLoading(false);
        }
    };

    // 点击模块框确认
    useEffect(() => {
        if (confirmData.isClickOk) {
            submitHandle();
        } else {
            setIsClickSubmit(false);
        }
    }, [confirmData]);

    // 点击提交确认
    useEffect(() => {
        if (isClickSubmit) {
            checkFormMenuHandle();
        }
    }, [isClickSubmit]);

    // 数据本地存储
    const saveFormDataHandle = () => {
        setlocal('formData', formData);
        Toast.show({
            content: '暫存成功',
            maskClickable: false,
        });
    };

    // 数据初始化
    useEffect(() => {
        const formData = getlocal('formData');

        // 更新数据初始化
        if (!updateId) {
            getHostHandle(!updateId);

            return false;
        }

        // 储存数据初始化
        if (formData) {
            setFormData({
                ...formData,
            });
        }
    }, []);

    return (
        <div className={styles.layout}>
            <Banner />
            <Required
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
            />
            <Media
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
                updateId={updateId}
                updateSuccess={updateSuccess}
            />
            <Needlessly
                formData={formData}
                setFormDataHandle={setFormDataHandle}
                warningTextList={warningTextList}
                updateSuccess={updateSuccess}
            />
            <div className={styles.limtDate}>截止日期:2024年12月06日</div>
            <FormInfo understand={understand} understandHandle={understandHandle} />
            <FormSubmit clickSubmitHandle={setIsClickSubmit} saveFormDataHandle={saveFormDataHandle} />
            <Confirm confirmData={confirmData} confirmDataHandle={confirmDataHandle} updateId={updateId} />
            {hasSucessPopup && <Success updateId={updateId} />}
            {isShowLoading && (
                <div className={styles.loadingBox}>
                    <SpinLoading color="#CE6400" />
                </div>
            )}
            <SecondShare />
        </div>
    );
};

export default errorBoundary(Layout);
